import { z } from 'zod';

/**
 * SupportHours interface
 * Represents the hours of operation for the support line for a particular day.
 */
const DayOfWeek = {
    MONDAY: 'monday',
    TUESDAY: 'tuesday',
    WEDNESDAY: 'wednesday',
    THURSDAY: 'thursday',
    FRIDAY: 'friday',
    SATURDAY: 'saturday',
    SUNDAY: 'sunday',
};
const dayOfWeekValues = [
    DayOfWeek.MONDAY,
    DayOfWeek.TUESDAY,
    DayOfWeek.WEDNESDAY,
    DayOfWeek.THURSDAY,
    DayOfWeek.FRIDAY,
    DayOfWeek.SATURDAY,
    DayOfWeek.SUNDAY,
];
const dayOfWeekSchema = z.enum(dayOfWeekValues);
//--------------------------------
// Zod Schemas
//--------------------------------
const supportHoursSchema = z.object({
    day: dayOfWeekSchema,
    open: z.string(),
    close: z.string(),
});
const supportScheduleSchema = z.record(dayOfWeekSchema, supportHoursSchema);

export { DayOfWeek, dayOfWeekSchema, dayOfWeekValues, supportHoursSchema, supportScheduleSchema };
//# sourceMappingURL=SupportHours.js.map
